// ##### 25-02-15 Komarov
import React from 'react';
// ##### 23-10-30 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import ContentDetails from './ContentDetails';

// ##### Komarov 2025-07-14
const ContentBlock = ({ hotel_id }) => {
  return (
    <>
      <Media lessThan="Tablet-768-1024">
        <ContentDetails
          className="ContentDetailsSmallScreen"
          hotel_id={hotel_id}
        />
      </Media>
      <Media greaterThanOrEqual="Tablet-768-1024">
        <ContentDetails className="ContentDetails" hotel_id={hotel_id} />
      </Media>
    </>
  );
};

export default ContentBlock;
